export default "__VITE_ASSET__Bbn8AGhh__"